import { gql } from '@apollo/client';

import { VideoFragment } from '../fragments/videoFragment';

export default gql`
  query VideoById($courseId: String!, $subjectId: String!, $videoId: String) {
    video(courseId: $courseId, subjectId: $subjectId, videoId: $videoId)
      @rest(type: "Video", path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.videoId}") {
      ...Video
    }
  }
  ${VideoFragment}
`;
